module.exports = __webpack_public_path__ + "static/media/commitTime.b65a732a.build-env";